<div class="manage-jobs-dialog">
  <div mat-dialog-title class="dialog-header">
    <div class="dialog-header__top">
      <p class="dialog-title">{{ 'translations.jobs.manageJobs' | transloco }}</p>
      <button mat-icon-button type="button" class="dialog-header__close-icon" tabindex="0" aria-label="Close" (click)="close()">
        <mat-icon>close</mat-icon>
      </button>
    </div>
    <p class="dialog-subtitle">{{ data.user.firstName }} {{ data.user.lastName }}</p>
  </div>

  <mat-dialog-content>
    <div class="manage-jobs">
      <div class="loading-wrapper" *ngIf="isLoading">
        <mat-spinner diameter="40"></mat-spinner>
      </div>

      <div class="jobs-container" *ngIf="!isLoading">
        <div class="assigned-jobs-section">
          <p class="section-title">{{ 'translations.jobs.assignedJobs' | transloco }}</p>
          <ul class="jobs-list" *ngIf="userJobs.length">
            <li *ngFor="let job of userJobs" class="job-item">
              <div class="job-info">
                <span
                  class="job-status-indicator"
                  [class.job-status-indicator--active]="isJobActive(job)"
                  [class.job-status-indicator--ended]="!isJobActive(job)"
                ></span>
                <div class="job-info-column">
                  <span class="job-title">{{ job.title }}</span>
                  <span class="job-level">{{ job.level }}</span>
                  <div class="job-item__dates">
                    <mat-icon>calendar_today</mat-icon>
                    <span>
                      {{ job.startDate | date: 'mediumDate' }} -
                      {{ job.endDate ? (job.endDate | date: 'mediumDate') : ('translations.global.label.present' | transloco) }}
                    </span>
                  </div>
                </div>
              </div>
              <button mat-stroked-button class="remove-btn" (click)="onRemoveJob(job._id)" type="button">
                {{ 'translations.global.button.remove' | transloco }}
              </button>
            </li>
          </ul>
          <p class="empty-message" *ngIf="!userJobs.length">{{ 'translations.jobs.noJobsAssigned' | transloco }}</p>
        </div>

        <div class="add-job-section">
          <button
            *ngIf="!showCreateForm"
            mat-stroked-button
            color="primary"
            class="add-job-btn"
            (click)="showCreateForm = true"
            type="button"
          >
            <mat-icon>add</mat-icon>
            {{ 'translations.jobs.addNewJob' | transloco }}
          </button>

          <form *ngIf="showCreateForm" [formGroup]="jobForm" class="create-job-form" (ngSubmit)="onCreateJob()">
            <mat-form-field appearance="outline">
              <mat-label>Title</mat-label>
              <input matInput formControlName="title" />
            </mat-form-field>

            <mat-form-field appearance="outline">
              <mat-label>Level</mat-label>
              <input matInput formControlName="level" />
            </mat-form-field>

            <div class="date-fields">
              <mat-form-field appearance="outline">
                <mat-label>Start Date</mat-label>
                <input matInput [matDatepicker]="startPicker" formControlName="startDate" />
                <mat-datepicker-toggle matSuffix [for]="startPicker"></mat-datepicker-toggle>
                <mat-datepicker #startPicker></mat-datepicker>
              </mat-form-field>

              <mat-form-field appearance="outline">
                <mat-label>End Date</mat-label>
                <input matInput [matDatepicker]="endPicker" formControlName="endDate" />
                <mat-datepicker-toggle matSuffix [for]="endPicker"></mat-datepicker-toggle>
                <mat-datepicker #endPicker></mat-datepicker>
              </mat-form-field>
            </div>

            <div class="form-actions">
              <button mat-stroked-button type="button" (click)="showCreateForm = false; jobForm.reset()">
                {{ 'translations.global.button.cancel' | transloco }}
              </button>
              <button mat-flat-button color="primary" [disabled]="jobForm.invalid || isLoading" type="submit">
                {{ 'translations.jobs.createJob' | transloco }}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </mat-dialog-content>
</div>
